// src/utils/logger.ts

const IS_DEV = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Debug логи (только в dev режиме)
   */
  debug: (message: string, ...args: any[]) => {
    if (IS_DEV) console.log(message, ...args);
  },

  /**
   * Info логи (только в dev режиме)
   */
  info: (message: string, ...args: any[]) => {
    if (IS_DEV) console.info(message, ...args);
  },

  /**
   * Warning логи (всегда)
   */
  warn: (message: string, ...args: any[]) => {
    console.warn(message, ...args);
  },

  /**
   * Error логи (всегда)
   */
  error: (message: string, ...args: any[]) => {
    console.error(message, ...args);
  },
};